<template id="t">
    <v-btn round depressed color="warning" @click="doCopy">Copy!</v-btn>
</template>

<script>
    import {mapMutations} from "vuex";

    export default {
        name: "Copy",
        props: ['text'],
        methods: {
            doCopy: function () {
                let that = this
                this.$copyText(this.text).then(function () {
                    that.handleCopyStatus(true)
                }, function () {
                    that.handleCopyStatus(false)
                })
            },
            ...mapMutations('notification', ['showSnackbar']),
            handleCopyStatus(status) {
                if (status) {
                    this.showSnackbar({text: 'Coppied!', type: 'info'})
                }
            }
        }
    }
</script>
